/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { LoraDevice } from '@enmon/commons/lib/tools';
import { MeterRegister } from '@enmon/commons';
import { BaseApiClient } from './baseApiClient';

interface UpMessagesParams {
  from: Date;
  to: Date;
  limit?: number;
  sort?: string;
}

export interface LoraDeviceResponse {
  attributes: Record<string, string>;
  bateryStatus: number;
  counters: { messageInDaily: number; messageOutDaily: number };
  custDeviceName: string;
  custServiceId: string;
  customerId: string;
  deviceGroups: [
    {
      deviceGroupDesc: string;
      deviceGroupId: number;
      deviceGroupName: string;
      links: { self: string };
      projectId: string;
    },
  ];
  deviceId: string;
  disableTime: null;
  enableTime: string;
  enabled: true;
  lastMessageIn: string;
  lastMessageOut: string;
  limits: { messageInDaily: number; messageOutDaily: number };
  links: { self: string };
  parameters: { rxw: string; seqrelax: string; devicetype: string; devclass: string };
  projectId: string;
  provisionTime: string;
  resumeTime: null;
  signalStrength: number;
  status: null;
  suspendTime: null;
  suspended: false;
  tags: [];
}

export interface LoraDeviceMessagesResponse {
  count: number;
  total: number;
  data: {
    id: string;
    message: {
      EUI: string;
      ack: boolean;
      bat: number;
      cmd: string;
      data: string;
      dr: string;
      encdata: unknown;
      fcnt: number;
      freq: number;
      port: number;
      seqno: number;
      toa: number;
      ts: number;
      gws: { gweui: string; lat: number; lon: number; rssi: number; snr: number; ts: number }[];
    };
    messageTime: string;
  }[];
}

export interface CreateLoraDeviceResponse {
  status: 'success' | 'error';
  data?: {
    batchId: string;
    links: { self: string };
  };
  errors?: {
    code: number;
    message: string;
    attribute: {
      custServiceId: string;
      tenantId: string;
      userId: string;
    };
  };
}
export class LoraApiClient extends BaseApiClient<LoraDeviceResponse> {
  constructor() {
    super('enmon-tools/lora');
  }

  async getDevice(dataSourceId: MeterRegister['dataSourceId']): Promise<LoraDeviceResponse> {
    const response = await this.http.get<{ data: LoraDeviceResponse }>(`/devices/${dataSourceId}`);
    return response.data;
  }

  /**
   * To get up messages for device
   * messages can't be more than 30 days apart
   * https://app.swaggerhub.com/apis-docs/cra-iot/GUI/1.0.32#/LoRa%20Devices/get_lora_devices__id__up_messages
   * @param {InventoryMeter['data_source_id']} dataSourceId
   * @param {UpMessagesParams} params
   * @returns
   */
  async getDeviceUpMessages(
    dataSourceId: MeterRegister['dataSourceId'],
    params: UpMessagesParams,
  ): Promise<LoraDeviceMessagesResponse> {
    const response = await this.http.get<LoraDeviceMessagesResponse>(`/devices/${dataSourceId}/messages`, {
      params,
    });

    return response;
  }

  async registerDevice(loraDeviceId: LoraDevice['dev_eui']): Promise<CreateLoraDeviceResponse> {
    const response = await this.http.put<CreateLoraDeviceResponse>(`/devices/${loraDeviceId}/register`, {});
    return response;
  }
}
